module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightsnow-49fef9f245880afc68571ca10e3aaee8.svg";